<div class="col">
  <div>
    <div class="card-container card">
      <div class="card-header d-flex justify-content-center" style="background-color: #e7e6e6">
        <div class="card-header-title">
          <h4 class="card-title"><label>HELPING YOU SELL</label></h4>
        </div>
      </div>
      <div *ngIf="arbCentralSecurityFunctions$ | async as arbCentralSecurityFunctions" class="d-flex justify-content-evenly">
        <div class="d-flex align-items-center" *ngIf="scrollContainer.scrollWidth > scrollContainer.clientWidth" (click)="scrollLefta()">
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_left</mat-icon>
        </div>
        <div
          class="d-flex overflow-auto my-help-component-lista"
          style="scroll-behavior: smooth; scrollbar-width: none; -ms-overflow-style: none"
          #scrollContainer
        >
          <style>
            .my-help-component-lista::-webkit-scrollbar {
              display: none;
            }
          </style>
          <div
            *ngIf="arbCentralSecurityFunctions?.HYS_ARBProductCatalogueActionTF"
            class="d-flex justify-content-center p-2"
            (click)="navigateTo('/epc')"
          >
            <button class="btn catalougue">
              <span class="background-layer">
                <span class="text-background"> PRODUCT CATALOGUE </span>
              </span>
            </button>
          </div>
          <div *ngIf="arbCentralSecurityFunctions?.HYS_StartNewQuoteActionTF" class="d-flex justify-content-center p-2" (click)="startNewQuote()">
            <button class="btn new_quote">
              <span class="background-layer">
                <span class="text-background"> START NEW QUOTE</span>
              </span>
            </button>
          </div>
          <div
            *ngIf="arbCentralSecurityFunctions?.HYS_ExistingQuoteActionTF"
            class="d-flex justify-content-center p-2"
            (click)="navigateTo('pos/my-orders/quotes')"
          >
            <button class="btn exist_quote">
              <span class="background-layer"> <span class="text-background"> EXISTING QUOTE</span></span>
            </button>
          </div>
          <div
            *ngIf="arbCentralSecurityFunctions?.HYS_QuoteToARBOrderActionTF"
            class="d-flex justify-content-center p-2"
            (click)="navigateTo('pos/my-orders/quotes')"
          >
            <button class="btn quote_to_arb">
              <span class="background-layer"> <span class="text-background"> QUOTE TO ORDER</span></span>
            </button>
          </div>
          <div
            *ngIf="arbCentralSecurityFunctions?.HYS_ARBOrderWithoutQuoteActionTF"
            class="d-flex justify-content-center p-2"
            (click)="goToOrderWithoutQuote()"
          >
            <button class="btn arb_order">
              <span class="background-layer">
                <span class="text-background"> ORDER WITHOUT QUOTE</span>
              </span>
            </button>
          </div>
        </div>
        <div
          class="d-flex justify-content-end align-items-center"
          *ngIf="scrollContainer.scrollWidth > scrollContainer.clientWidth"
          (click)="scrollRighta()"
        >
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_right</mat-icon>
        </div>
      </div>

      <!-- <app-product-info-bulletin-email class="card-container"></app-product-info-bulletin-email> -->
      <div class="border"></div>
    </div>
  </div>
</div>
